/* eslint-disable max-lines-per-function */
export const initSentry = (config) => {
    if (!config) {
        return;
    }

    const ignoreErrors = [
        '"adguard" не определено',
        "Cannot convert 'window.jsbSmile' to object",
        "Cannot read property 'uplListener' of undefined",
        'DealPly is not defined',
        'NS_ERROR_XPC_BAD_OP_ON_WN_PROTO: Illegal operation on WrappedNative prototype object',
        'NS_NOINTERFACE: Component does not have requested interface [nsIDOMLocation.reload]',
        'ReferenceError: Components is not defined',
        'TypeError: freecorder.extension is undefined',
        'Uncaught Error: Attempting to use a disconnected port object',
        'Uncaught Error: chrome.browserAction can only be used in extension processes. See the content scripts documentation for more details.',
        'Uncaught Error: Error connecting to extension mpcknfcdcgpffjddjeceioobdelceffo',
        'Uncaught exception: TypeError: \'$$(".ruBar_widgetRequest_" + msg.widget)[msg.widget]\' is not a function',
        'Uncaught ReferenceError: adguard is not defined',
        'Uncaught ReferenceError: stopme is not defined',
        'window.jsbSmile is undefined',
        'already sended to server',
    ];
    
    const getSettings = () => {
        return (window as any).cloudSettings || { state: {}, request: {}, params: {} };
    }
    
    const getTextForRadar = (val, prefix = '') => {
        return val ? prefix + val.replace(/[^A-Za-z0-9]/g, '').toLowerCase() : '';
    }
    
    const logToKaktam = (obj, type, value) => {
        if (!obj.exception || !obj.exception.values || !obj.exception.values.length) {
            return;
        }
    
        // где смотреть: grepmaillog11 ~]$ tail /mnt/maillogs/kaktam/cloud_JsError*.log -f
        const radarKaktam = window.RADAR.group('jsError');
        const stacktrace = obj.exception.values[0].stacktrace;
        const settings = getSettings();
        let stack = '';
    
        if (stacktrace && stacktrace.frames) {
            for (let i = 0; i < stacktrace.frames.length && i < 15; i++) {
                stack += `${stacktrace.frames[i].function}(line:${stacktrace.frames[i].lineno}), `;
            }
        }
    
        radarKaktam.kaktam(
            'JsError',
            JSON.stringify({
                type,
                isoDate: new Date().toISOString(),
                message: value,
                stack,
                storage: settings.state.storage,
                url: settings.request.uri_full,
            })
        );
    
        radarKaktam.send();
    }
    
    const logKaktam = (errorData, event) => {
        const source = errorData.source;
        const value = errorData.value;
        const type = errorData.type;
    
        if (source === 'unknown') {
            return;
        }
    
        let valuePart = '';
        const typePart = getTextForRadar(type);
    
        //  получение имени переменной, на которой ошибка (примерно)
        if (type === 'ReferenceError' && value.indexOf('is not defined') > 0) {
            valuePart = getTextForRadar(value.split(' ')[0], '');
        } else if (type === 'TypeError' && value.indexOf('Cannot read property') > 0) {
            const propName = value.match(/'([A-Za-z0-9]*)'/);
            valuePart = getTextForRadar(propName ? propName[0] : null, '');
        }
    
        let label = 'project-js';
        if (source === 'non-project') {
            label = 'js';
        } else if (type === 'Error' || (type === 'TypeError' && !valuePart)) {
            logToKaktam(event, type, value);
        }
    
        window.RADAR.error(label);
        const radarDesc = window.RADAR.group(`error_${label.toString()}${typePart.toString()}`);
    
        if (valuePart) {
            radarDesc.add('name', valuePart);
        }
    
        radarDesc.send();
    }

    function getErrorData(exception) {
        if (!exception || !exception.values || !exception.values.length || !exception.values[0].stacktrace) {
            return {
                source_type: 'unknown',
            };
        }

        const type = exception.values[0].type || '';
        const value = exception.values[0].value || '';
        const errorFileName = exception.values[0].stacktrace.frames[0].filename || '';

        const feature = config.feature || {};
        const matcher = feature.culpritMatcher || '^https?:\\/\\/(cloud\\.|img\\.imgs)mail\\.ru\\/';
        const isProjectError = errorFileName.match(new RegExp(matcher, 'i'));

        return {
            type,
            value,
            source: isProjectError ? 'project' : 'non-project',
        };
    }

    function beforeSend(event) {
        const tags = event.tags || {};
        const extra = event.extra;
        const level = event.level;
        const feature = config.feature || {};
        const settings = getSettings();

        if (!feature.shouldSendCaptureMessage && level === 'info') {
            return null;
        }

        if (extra) {
            extra.href = typeof location === 'object' && location !== null && location.href;
            extra.inFrame = window.parent !== window;
            extra.domain = document.domain;
            extra['x-page-id'] = settings.params['x-page-id'];
            extra.buildUrl = config.buildUrl;

            delete extra.arguments;
            delete extra.state;
        }

        const errorData = getErrorData(event.exception);

        tags.source_type = errorData.source;
        tags.exeption_type = errorData.type;
        tags.storage = settings.state.storage;
        tags.hasAdblock = (window as any).__knownBlocker || false;

        event.tags = tags;

        if (level === 'error') {
            logKaktam(errorData, event);
        }

        if (feature.debug) {
            console.error(event);
        }

        return event;
    }

    function initialScope(scope) {
        const userEmail = config.user;

        if (userEmail) {
            scope.setUser({ email: userEmail });
        }

        return scope;
    }

    const feature = config.feature || {};

    (window as any).Sentry.init({
        dsn: config.dsn,
        ignoreErrors,
        debug: feature.debug || false,
        autoSessionTracking: 'autoSessionTracking' in feature ? feature.autoSessionTracking : true,
        sampleRate: config.sampleRate,
        release: config.build,
        environment: config.environment,
        integrations: [new (window as any).Sentry.Integrations.Breadcrumbs({ console: false, fetch: true })],
        // Chrome extensions
        denyUrls: [/^extensions\/.+/i, /^chrome:\/\/.+/i, /^res:\/\/.+/i, /.*miscellaneous_bindings.*/i],
        initialScope,
        beforeSend
    });
};
